<template>
  <span class="text-no-wrap">
    {{ value }}
  </span>
</template>

<script>
export default {
	name: 'Refreshable',

	props: {
		lambda: {
			type: Function,
			required: true,
		},
		interval: {
			type: Number,
			default: 500,
		},
	},
	data: () => ({
		intervalId: undefined,
		value: undefined,
	}),
	created() {
		this.intervalId = setInterval(() => {
			this.value = this.lambda()
		}, this.interval)
	},
	beforeDestroy() {
		clearInterval(this.intervalId)
	},
}
</script>

<style lang="scss">
</style>
